module.exports = __webpack_public_path__ + "d308073b/img/settings-ico.a214628d.svg";